import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { isEmpty, difference } from 'lodash';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import { Container, Row, Col } from 'react-bootstrap';
import InfiniteScroll from 'react-infinite-scroll-component';
import BtnAdd from '../../../Components/Utility/FilterAction/BtnAdd';
import BtnDelete from '../../../Components/Utility/FilterAction/BtnDelete';
import SearchBar from '../../../Components/Utility/FilterAction/SearchBar';
import {
  deleteUsersLibraryGroup,
  fetchSupplierUsersList,
  fetchUserGroupsCards,
  fetchUsersLibrary,
  resetPasswordMail,
  updateUsersLibraryStatus,
} from '../store/User.action';
import {
  fetchAllBrandAction,
  fetchCategoryAction,
  fetchRightsAssignmentAction,
  updateUserStatus,
} from '../../Supplier/store/Supplier.action';
import { getMultiSubBrandDetails } from '../../SystemMasters/Store/SystemMasters.action';
import Loader from '../../../Components/Utility/Loader/Loader';
import AddEditUsersModel from './AddEditUsersModel';
import { Page_Size } from '../../../Components/helper';
import BtnSort from '../../../Components/Utility/FilterAction/BtnSort';
import SupplierUserAssignmentModal from './SupplierUserAssignmentModal';
import { recoverUsersMFA } from '../../Auth/store/Auth.action';
import SetNewPasswordModal from './SetNewPasswordModal';
import { NewCheckbox } from '../../../Components/PIM/common';
import { MoreIcon, CloseIcon, TickIcon, SetPasswordIcon, EditIcon, DeleteIcon, SettingsIcon, ResendPasswordIcon, TwoFAIcon } from '../../../bombiix-icon';

const elsePart = (selectedIdArray, usersList, setSelectedIdArray, setSelectAll) => {
  const selectedItems = [...selectedIdArray];
  if (!Array.isArray(usersList)) {
    for (const item of usersList) {
      console.log(item, 'this is item');
      const findItems = selectedItems.filter((val) => val === item._id);
      if (findItems.length === 0) {
        selectedItems.push(item._id);
      }
    }
    setSelectedIdArray(selectedItems);
  } else {
    const Selected = [];
    usersList.forEach((ele) => {
      Selected.push(ele._id);
    });
    setSelectedIdArray([...Selected]);
    setSelectAll(true);
  }
};

function UsersLibrary() {
  const dispatch = useDispatch();
  const UsersReducers = useSelector((reducerstate) => reducerstate);
  const {
    UserDetails: { isCompanyAdminLoggedIn, isSupplierLoggedIn, userInfo },
  } = UsersReducers;
  const { userId } = userInfo;
  const [usersList, setUsersList] = useState([]);
  const [loading, setLoading] = useState(false);
  const { t } = useTranslation('common');
  const [selectedIdArray, setSelectedIdArray] = useState([]);
  const [isSelectAll, setSelectAll] = useState(false);
  const [addEditflag, setAddEditflag] = useState(false);
  const [selectedEditId, setSelectedEditId] = useState('');
  const [showSearchMobile, setSearchMobile] = useState(false);
  const [showChangePassModel, setShowChangePassModel] = useState(false);
  const [user, setUser] = useState({});

  const [state, setState] = useState({
    colourLibraryGroups: [],
    loading: false,
    searchText: '',
    searchLoaded: false,
    sortBy: null,
    pageIndex: 1,
    pageSize: Page_Size,
    totalRecords: 0,
    supplierAssignmentModal: false,
    userSelectedId: '',
  });
  const [brandAndCategoryData, setBrandAndCategoryData] = useState(null);

  const { supplierAssignmentModal, userSelectedId } = state;
  const { brands, categoryType1, categoryType2 } = useSelector((redState) => redState?.SuppliersDetails || {});
  const { multiSubBrandList } = useSelector((redState) => redState?.SystemMastersDetails || {});
  const sortByOptions = [
    {
      value: 'Asc',
      propertyName: 'referenceCode',
      label: t('USER_LIBRARY.USER_NAME_ASENDING'),
    },
    {
      value: 'Desc',
      propertyName: 'referenceCode',
      label: t('USER_LIBRARY.USER_NAME_DESCENDING'),
    },
  ];

  const manageUsersArray = (data, isAppend) => {
    const incoming = Array.isArray(data) ? data : (data?.list || []);
    const total = Array.isArray(data) ? 0 : (data?.totalRecords || 0);
    setUsersList((prev) => (isAppend ? [...prev, ...incoming] : incoming));
    setState((s) => ({ ...s, totalRecords: total }));
    setLoading(true);
  };

  const fetchApi = async () => {
    const supplierId = userId;
    if (isSupplierLoggedIn) {
      const res = await dispatch(fetchSupplierUsersList({ supplierId, queryParam: { pageIndex: 1, pageSize: Page_Size } }));
      await dispatch(fetchUserGroupsCards());
      if (res?.code === 200) manageUsersArray(res.data, false);
    } else {
      const res = await dispatch(fetchUsersLibrary({ pageIndex: 1, pageSize: Page_Size }));
      await dispatch(fetchUserGroupsCards());
      if (res?.code === 200) manageUsersArray(res.data, false);
    }
  };
  useEffect(() => {
    fetchApi();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const onDelete = async (id) => {
    await dispatch(deleteUsersLibraryGroup([id], t));
    await fetchApi();
  };

  const statusHandler = async (id, stateGoesTo) => {
    const data = {
      stateGoesTo: stateGoesTo === true ? t('USER_LIBRARY.DEACTIVATE') : t('USER_LIBRARY.ACTIVATE'),
    };
    if (isCompanyAdminLoggedIn) {
      data.userId = id;
      await dispatch(updateUsersLibraryStatus(data, t));
    }
    if (isSupplierLoggedIn) {
      data.supplierId = userId;
      await dispatch(updateUserStatus(data, id));
    }

    fetchApi();
  };

  const resetPasswordHandler = async (id, email) => {
    const data1 = {
      email,
      userId: id,
      supplierId: id,
    };
    if (isCompanyAdminLoggedIn) {
      data1.checkFor = 'User';
    }
    if (isSupplierLoggedIn) {
      data1.checkFor = 'SupplierUser';
    }

    console.log(data1, 'data');
    await dispatch(resetPasswordMail(data1, t));
    fetchApi();
  };

  const recoverMfa = async (id, email) => {
    const data1 = {
      email,
      userId: id,
    };
    await dispatch(recoverUsersMFA(data1, t));
    fetchApi();
  };

  const toggleChangePasswordModel = (ele) => {
    setShowChangePassModel((prev) => !prev);
    setUser(ele);
  };

  useEffect(() => {
    if (Array.isArray(usersList) && usersList?.length > 0) {
      const stateIds = usersList.map((item) => item._id);
      const selectedItems = [...selectedIdArray];
      const unSelectedItems = difference(stateIds, selectedItems);
      if (unSelectedItems.length > 0) {
        setSelectAll(false);
      } else {
        setSelectAll(true);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedIdArray]);

  const onSelectCheckBox = async (id) => {
    let selectedItems = [...selectedIdArray];
    const findItems = selectedItems.filter((item) => item === id);
    if (findItems.length > 0) {
      selectedItems = selectedItems.filter((item) => item !== id);
      setSelectedIdArray([...selectedItems]);
    } else {
      setSelectedIdArray([...selectedItems, id]);
    }
  };

  const handleSortBy = async (val) => {
    setState((prev) => ({ ...prev, sortBy: val, pageIndex: 1 }));
    const supplierId = userId;
    let res;
    if (isSupplierLoggedIn) {
      res = await dispatch(fetchSupplierUsersList({
        supplierId,
        queryParam: { sortByPropertyName: 'firstName', sortOrder: val?.value, pageIndex: 1, pageSize: Page_Size },
      }));
    } else {
      res = await dispatch(fetchUsersLibrary({
        sortByPropertyName: 'firstName',
        sortOrder: val?.value,
        pageIndex: 1,
        pageSize: Page_Size,
      }));
    }
    if (res?.code === 200) manageUsersArray(res.data, false);
  };

  const handleSearch = async (e) => {
    const targetValue = e.target.value;
    setState((searchstate) => ({
      ...searchstate,
      searchText: targetValue,
      searchLoaded: true,
    }));
  };

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      if (state.searchLoaded) {
        const supplierId = userId;
        let res;
        if (isSupplierLoggedIn) {
          res = await dispatch(fetchSupplierUsersList({
            supplierId,
            queryParam: { searchText: state.searchText, pageIndex: 1, pageSize: Page_Size },
          }));
        } else {
          res = await dispatch(fetchUsersLibrary({
            searchText: state.searchText,
            pageIndex: 1,
            pageSize: Page_Size,
          }));
        }
        if (res?.code === 200) manageUsersArray(res.data, false);
        setState((getstate) => ({
          ...getstate,
          searchLoaded: false,
          pageIndex: 1,
        }));
      }
    }, 1000);

    return () => clearTimeout(delayDebounceFn);
  }, [state.searchText]); // eslint-disable-line react-hooks/exhaustive-deps

  const handleSelectAll = () => {
    if (isSelectAll) {
      setSelectedIdArray([]);
    } else {
      elsePart(selectedIdArray, usersList, setSelectedIdArray, setSelectAll);
    }
    setSelectAll(!isSelectAll);
  };

  const fetchMore = async () => {
    const nextPage = state.pageIndex + 1;
    setState((prev) => ({ ...prev, pageIndex: nextPage }));
    const supplierId = userId;
    const queryParam = {
      searchText: state.searchText,
      sortByPropertyName: state.sortBy ? 'firstName' : undefined,
      sortOrder: state.sortBy?.value,
      pageIndex: nextPage,
      pageSize: Page_Size,
    };
    const res = isSupplierLoggedIn
      ? await dispatch(fetchSupplierUsersList({ supplierId, queryParam }))
      : await dispatch(fetchUsersLibrary(queryParam));
    if (res?.code === 200) manageUsersArray(res.data, true);
  };

  const deleteMultiple = async () => {
    console.log(selectedIdArray, 'selectedIdArray working');
    await dispatch(deleteUsersLibraryGroup(selectedIdArray, t));
    fetchApi();
  };

  const modelHandler = () => {
    setSelectedEditId(null);
    setAddEditflag(!addEditflag);
  };
  const titles = () => {
    return !isEmpty(selectedEditId) ? t('USER_LIBRARY.UPDATE_USER') : t('USER_LIBRARY.ADD_USER');
  };

  const edidHandler = (ele) => {
    setSelectedEditId(ele?._id);
    setAddEditflag(true);
  };
  const handleMobileSearch = (clear) => {
    console.log(clear);
    if (clear) {
      setState((mobstate) => ({
        ...mobstate,
        searchText: '',
        searchLoaded: true,
      }));
    }
    setSearchMobile(!showSearchMobile);
  };

  const handleSupplierUserAssignment = async (id) => {
    const rightsAssignment = await dispatch(fetchRightsAssignmentAction({ userId: id }));
    await dispatch(
      fetchAllBrandAction({
        accessedFrom: 'masters',
        loggedInUserId: userId,
      }),
    );
    await dispatch(
      fetchCategoryAction({
        accessedFrom: 'masters',
        categoryType: 1,
        loggedInUserId: userId,
      }),
    );
    await dispatch(
      supplierAction.fetchCategory2Action({
        accessedFrom: 'masters',
        categoryType: 2,
        loggedInUserId: userId,
      }),
    );
    await dispatch(
      getMultiSubBrandDetails({
        isActive: true,
      }),
    );
    setBrandAndCategoryData({ rightsAssignment, loggedInUserId: userId, id });
    setState((prev) => ({
      ...prev,
      supplierAssignmentModal: true,
      userSelectedId: id,
    }));
  };
  const hasMore = usersList.length < state.totalRecords;
  return (
    <>
      <div className="page-title-filter sticky d-fex">
        <div className="title-container">
          <h4 className="title">{t('USER_LIBRARY.USER_LIBRARY_MANAGEMENT')}</h4>
        </div>
        <div className="search-filter" style={{ paddingLeft: '45%' }}>
          <SearchBar
            placeholder={t('USER_LIBRARY.PLACEHOLDERS')}
            onSearch={handleSearch}
            value={state.searchText}
            showMobileSearch={showSearchMobile}
            handleMobileSearch={handleMobileSearch}
          />
          <div className="web-filter">
            <BtnAdd onBtnClick={modelHandler} addEditAccess />
            <BtnSort options={sortByOptions} onBtnClick={handleSortBy} val={state.sortBy} />
            <BtnDelete
              multiDelete={() => {
                deleteMultiple();
              }}
              isDisabled={isEmpty(selectedIdArray)}
            />
          </div>
          <button type="button" className="filter-btn btn-mobile-more">
            <MoreIcon size={28} />
          </button>
        </div>
      </div>
      {!isSupplierLoggedIn && (
        <div className="container-fluid">
          <div className="d-flex justify-content-end my-3">
            <Link
              className={`cursor-pointer text-dark text-decoration-none ${
                window.location.href.includes('/user-library') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
              }`}
              to="/settings/user-library"
            >
              <span className="lib-name">{t('USER_LIBRARY.USER_LIBRARY')}</span>
            </Link>
            <Link
              className={`cursor-pointer text-dark text-decoration-none ${
                window.location.href.includes('/user-groups') ? 'btn-active btn btn-page-filter' : 'btn btn-page-filter'
              }`}
              to="/settings/user-groups"
            >
              <span className="lib-name">{t('USER_LIBRARY.USER_GROUPS')}</span>
            </Link>
          </div>
        </div>
      )}
      {/* *****listing table***** */}
      {loading === true && usersList && isEmpty(usersList) && (
        <div>
          <div className="w-100 text-center">
            <Container fluid className="py-4">
              <Row>
                <Col md="12">
                  <p className="alert alert-info override-alert-info">{t('USER_LIBRARY.NO_USER_LIBRARY')}</p>
                </Col>
              </Row>
            </Container>
          </div>
        </div>
      )}

      {loading === false ? (
        <Loader />
      ) : (
        loading === true &&
        usersList &&
        !isEmpty(usersList) && (
          <div className="full-width-block m-4">
            <InfiniteScroll
              dataLength={usersList.length}
              next={fetchMore}
              hasMore={hasMore}
              loader={<Loader />}
              scrollableTarget="scrollableDiv"
            >
            <div className="table-responsive table-max-h-60 pb-4">
              <table className="table custom-table font-13">
                <thead>
                  <tr>
                    <th style={{ textAlign: 'centre', width: '5%' }}>
                      <div className="d-flex justify-content-center">
                        <NewCheckbox onChange={handleSelectAll} name="check_all" id="check_all" checked={isSelectAll} disabled={isEmpty(usersList)} />
                      </div>
                    </th>
                    <th>{t('USER_LIBRARY.FIRST_NAME')}</th>
                    <th>{t('USER_LIBRARY.LAST_NAME')}</th>
                    <th>{t('USER_LIBRARY.JOB_TITLE')}</th>
                    <th style={{ width: '25%' }}>{t('USER_LIBRARY.EMAIL')}</th>
                    <th>{t('USER_LIBRARY.STATUS')}</th>
                    <th className="w-150px">{t('USER_LIBRARY.ACTION')}</th>
                  </tr>
                </thead>
                <tbody>
                  {usersList?.map((ele, i) => (
                      <tr key={ele.id}>
                        <td>
                          <div className="d-flex justify-content-center">
                            <NewCheckbox
                              onChange={() => onSelectCheckBox(ele._id)}
                              name={`checks_${i}`}
                              id={`checks_${i}`}
                              checked={selectedIdArray.filter((val) => val === ele._id).length > 0}
                            />
                          </div>
                        </td>
                        <td>{ele?.firstName}</td>
                        <td>{ele?.lastName}</td>
                        <td>{ele?.title}</td>
                        <td>{ele?.email}</td>
                        <td>
                          {ele?.accountVerified === true ? (
                            <p
                              style={{
                                fontSize: '14px',
                                color: 'green',
                                fontWeight: '550',
                              }}
                            >
                              {t('USER_LIBRARY.ENABLED')}
                            </p>
                          ) : (
                            <p
                              style={{
                                fontSize: '14px',
                                color: 'red',
                                fontWeight: '550',
                              }}
                            >
                              {t('USER_LIBRARY.DISABLED')}
                            </p>
                          )}
                        </td>
                        <td>
                          <div className="d-flex align-items-center ">
                            <button
                              type="button"
                              className="btn btn-action"
                              title={ele?.accountVerified ? t('USER_LIBRARY.DISABLED') : t('USER_LIBRARY.ENABLED')}
                              onClick={() => {
                                statusHandler(ele._id, ele.accountVerified);
                              }}
                            >
                              {ele?.accountVerified ? (
                                <CloseIcon size={24} className="cursor-pointer" style={{ color: 'red' }} />
                              ) : (
                                <TickIcon size={24} style={{ color: 'green' }} />
                              )}
                            </button>
                            <button
                            className="btn btn-action cursor-pointer text-dark text-decoration-none"
                            title={t('USER_LIBRARY.SET_PASSWORD')}
                            aria-label={t('USER_LIBRARY.SET_PASSWORD')}
                            onClick={() => {
                              toggleChangePasswordModel(ele);
                            }}
                            type="button"
                            disabled={!ele?.accountVerified}
                          >
                            <SetPasswordIcon size={24} />
                          </button>

                          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                          <button
                            className="btn btn-action cursor-pointer text-dark text-decoration-none"
                            title={t('USER_LIBRARY.EDIT')}
                            type="button"
                            onClick={() => {
                              edidHandler(ele);
                            }}
                          >
                            <EditIcon size={24} />
                          </button>

                          {/* eslint-disable-next-line jsx-a11y/control-has-associated-label */}
                          <button
                            className="btn btn-action cursor-pointer text-dark text-decoration-none"
                            title={t('USER_LIBRARY.DELETE')}
                            type="button"
                            onClick={() => {
                              onDelete(ele._id);
                            }}
                          >
                            <DeleteIcon size={24} />
                          </button>
                          {isSupplierLoggedIn && (
                            // eslint-disable-next-line jsx-a11y/control-has-associated-label
                            <button
                              type="button"
                              className="btn btn-action cursor-pointer text-dark text-decoration-none"
                              title={t('USER_LIBRARY.BRANDS_CATEGORIES')}
                              onClick={() => handleSupplierUserAssignment(ele?._id)}
                            >
                              <SettingsIcon size={24} />
                            </button>
                          )}

                          {!ele.hasPassword && !ele.hasSsoLink && (
                            // eslint-disable-next-line jsx-a11y/control-has-associated-label
                            <button
                              type="button"
                              className="btn btn-action cursor-pointer text-dark text-decoration-none"
                              onClick={() => {
                                resetPasswordHandler(ele._id, ele.email);
                              }}
                              title={t('USER_LIBRARY.RESENT_SET_EMAIL')}
                            >
                              <ResendPasswordIcon size={24} />
                            </button>
                          )}
                          <button
                            className="btn btn-action text-dark text-decoration-none"
                            title={t('USER_LIBRARY.RESET_2FA')}
                            type="button"
                            aria-label={t('USER_LIBRARY.RECOVER_2FA')}
                            disabled={!ele.mfaEnabled}
                            style={{
                              pointerEvents: 'auto',
                            }}
                            onClick={() => {
                              recoverMfa(ele._id, ele.email);
                            }}
                          >
                            <TwoFAIcon size={24} />
                          </button>
                        </div>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
            </InfiniteScroll>
          </div>
        )
      )}
      {/* ****model**** */}
      {addEditflag && <AddEditUsersModel toggle={modelHandler} onSave={fetchApi} title={titles()} onOpen={addEditflag} id={selectedEditId} itemList={usersList} />}

      {supplierAssignmentModal && (
        <SupplierUserAssignmentModal
          data={brandAndCategoryData}
          toggle={() => {
            setState((prev) => ({
              ...prev,
              supplierAssignmentModal: false,
            }));
            setBrandAndCategoryData(null);
          }}
          show={supplierAssignmentModal}
          brands={brands}
          categoryType1={categoryType1}
          categoryType2={categoryType2}
          multiSubBrandList={multiSubBrandList}
        />
      )}
      {showChangePassModel && (
        <SetNewPasswordModal title={t('USER_LIBRARY.SET_NEW_PASSWORD')} user={user} show={showChangePassModel} toggle={toggleChangePasswordModel} />
      )}
    </>
  );
}

export default UsersLibrary;
